<template>
  <div>
    <div class="grid-container">
      <div class="grid-x legend-row">
        <div class="small-10 cell">
          <h2 v-if="rareMode">
            1+ Flag Applications
          </h2>
          <h2 v-if="!rareMode">
            How many 1+ flag applications do other organisations receive?
          </h2>
        </div>
        <div class="small-2 cell text-right">
          <rare-chart-rank
            :total="baseTotal"
            :rank="baseRank"
            :display="displayRank"
          />
        </div>
      </div>

      <div v-if="displayMode === 'double' || displayMode === 'single'">
        <div class="grid-x graph-row">
          <div
            v-if="displayMode === 'single'"
            class="small-1 cell"
          >
&nbsp;
          </div>
          <div
            class="cell"
            style="margin-left: -20px;"
            :class="{
              'small-10': displayMode === 'single',
              'small-6': displayMode === 'double',
            }"
          >
            <rare-industry-overview-base-chart
              :name-in-labels="nameInLabels"
              :chart-data="industryOverviewData.base"
              :labels="industryOverviewLabels.base"
              :color="industryOverviewColors.base"
              :legend-text="industryLegendDataThis"
              :canvas-i-d="'base'"
              :page="'industry'"
              :display-mode="displayMode"
              :max-decimal="industryMaxDecimal"
              :max-percentage="industryMaxPercentage"
              :total="calculateTotal(industryOverviewData.base,
                                     industryOverviewLabels.base)"
              :rank="calculateRank(industryOverviewLabels.base)"
            />
          </div>
          <div
            v-if="displayMode === 'double'"
            class="small-6 cell divider"
          >
            <rare-industry-overview-prev-chart
              :name-in-labels="nameInLabels"
              :chart-data="industryOverviewData.prevYear1"
              :labels="industryOverviewLabels.prevYear1"
              :color="industryOverviewColors.prevYear1"
              :legend-text="industryLegendDataPrev"
              :canvas-i-d="'prevYear'"
              :page="'industry'"
              :display-mode="displayMode"
              :max-decimal="industryMaxDecimal"
              :max-percentage="industryMaxPercentage"
              :total="calculateTotal(industryOverviewData.prevYear1,
                                     industryOverviewLabels.prevYear1)"
              :rank="calculateRank(industryOverviewLabels.prevYear1)"
            />
          </div>
          <div
            v-if="displayMode === 'single'"
            class="small-1 cell"
          >
&nbsp;
          </div>
        </div>
      </div>

      <div v-else-if="displayMode === 'table'">
        <rare-industry-3YOY-table
          :name-in-labels="nameInLabels"
          :client-names="industryOverviewTable.clientNameArray"
          :base-data="industryOverviewTable.baseDataArray"
          :prev-year1data="industryOverviewTable.prevYear1Array"
          :prev-year2data="industryOverviewTable.prevYear2Array"
          :prev-year3data="industryOverviewTable.prevYear3Array"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import RareIndustryOverviewChart from '../../components/charts/RareIndustryOverviewChart.vue';
import RareIndustryOverview3YOYTable from '../../components/charts/RareIndustryOverview3YOYTable.vue';
import RareChartRank from '../../components/controls/RareChartRank.vue';

export default {
  name: 'ClientSummary',
  components: {
    'rare-industry-overview-base-chart': RareIndustryOverviewChart,
    'rare-industry-overview-prev-chart': RareIndustryOverviewChart,
    'rare-industry-3YOY-table': RareIndustryOverview3YOYTable,
    'rare-chart-rank': RareChartRank,
  },
  data() {
    return {
      nameInLabels: '',
      initialLoad: true,
      chartData: {},
      industryOverviewData: {
        base: [0, 0, 0],
        prevYear1: [0, 0, 0],
        prevYear2: [0, 0, 0],
        prevYear3: [0, 0, 0],
      },
      industryOverviewLabels: {
        base: ['', '', ''],
        prevYear1: ['', '', ''],
        prevYear2: ['', '', ''],
        prevYear3: ['', '', ''],
      },
      industryOverviewColors: {
        base: 'blue',
        prevYear1: 'green',
        prevYear2: 'green',
        prevYear3: 'green',
      },
      industryOverviewTable: [],
      rankOffset: 0,
    };
  },
  computed: {
    ...mapGetters({
      displayMode: '$_industry/industryDisplayMode',
      getDataObject: '$_industry/getIndustryOverviewDataObject',
      getDataTable: '$_industry/getIndustryOverviewDataTable',
      industryLegendData: '$_industry/industryLegendData',
      industryMaxPercentage: '$_industry/industryPageMaxPercent',
      industryMaxDecimal: '$_industry/industryPageMaxDecimal',
      total: '$_industry/industryTotal',
      rank: '$_industry/industryRank',
      singleClientMode: 'singleClientMode',
      tableSortColumn: 'tableSortColumn',
      currentClient: 'currentClientDisplayName',
      comparisonMode: 'comparisonMode',
      comparisonYears: 'comparisonYears',
      dataFormat: 'dataFormat',
      rareMode: 'rareMode',
    }),
    displayRank() {
      return this.singleClientMode && ['single', 'table'].includes(this.displayMode);
    },
    industryLegendDataThis() {
      return `This year ${this.industryLegendData[0]}`;
    },
    industryLegendDataPrev() {
      return `Last year ${this.industryLegendData[1]}`;
    },
    baseTotal() {
      return this.calculateTotal(
        this.industryOverviewData.base,
        this.industryOverviewLabels.base,
      );
    },
    baseRank() {
      return this.calculateRank(
        this.industryOverviewLabels.base,
      );
    },
  },
  created() {
    this.$store.commit(
      'updatePageTitle',
      this.$store.getters.currentClientDisplayName,
    );
    this.$store.commit('updateShowLogoutIcon', true);
    this.$store.commit('updateShowDownloadIcon', true);
    this.$store.commit('updateShowNavigationLinks', true);
    this.$store.commit('updateShowControlPanel', true);
  },
  mounted() {
    this.track();
    document.title = `CRS Dashboard | ${this.$route.name}`;
    // this.renderCharts();
    this.updateCharts();

    this.$root.$on('updateClient', () => {
      this.clientChange();
    });
    this.$root.$on('updateCharts', () => {
      this.updateCharts();
    });
    this.$root.$on('renderCharts', () => {
      this.renderCharts();
    });
  },
  beforeDestroy() {
    this.$store.commit('updateInitialLoad', { page: 'industry', value: false });
    this.$store.commit(
      'updateCurrentParamsHash',
      'industryOverviewParamsExitHash',
    );
    this.$root.$off('updateClient');
    this.$root.$off('updateCharts');
    this.$root.$off('renderCharts');
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: `/industryoverview/${this.currentClient === '' ? 'rare' : this.currentClient}`,
      });
    },
    clientChange() {
      this.$store.commit(
        'updatePageTitle',
        this.$store.getters.currentClientDisplayName,
      );
      this.updateCharts();
    },
    calculateTotal(data, labels) {
      const total = parseInt(data.length, 10);
      const industryAverageOffset = labels.indexOf('industry_average') === -1 ? 0 : 1;
      return total - industryAverageOffset;
    },
    findNameInLabels(labels) {
      // We should be able to find the rank from searching for the display name in the labels array.
      // But sometimes the label contains the user name. To complicate things further sometimes the
      // Labels array contains neither the display or user name. In that case we resort to getting
      // The client name form the request params object and search for the username using that.
      const displayName = this.$store.getters.getDisplayNameFromUsername(this.currentClient);
      const userName = this.$store.getters.getUsernameFromDisplayName(this.currentClient);
      const displayNameWrong = labels.indexOf(displayName) === -1;
      const userNameWrong = labels.indexOf(userName) === -1;

      let nameInLabels;

      if (displayNameWrong && userNameWrong) {
        const requestParamsObj = this.$store.getters.requestParams;
        const requestParamsName = requestParamsObj.currentClient;
        nameInLabels = this.$store.getters.getUsernameFromDisplayName(requestParamsName);
        this.nameInLabels = nameInLabels;
      } else {
        nameInLabels = (displayNameWrong ? userName : displayName);
        this.nameInLabels = nameInLabels;
      }

      return nameInLabels;
    },
    calculateRank(labels) {
      const clientPos = labels.indexOf(this.findNameInLabels(labels));
      const industryAvPos = labels.indexOf('industry_average');
      const offset = ((this.dataFormat === 'decimal') || (clientPos < industryAvPos) || (industryAvPos === -1)) ? 1 : 0;
      return clientPos + offset;
    },
    updateCharts() {
      this.$store.commit('updateIndustryLoadingState', 'loading');
      this.$store.dispatch('$_industry/updateSummaryCharts').then(() => {
        this.renderCharts();
        if (this.comparisonMode === 'industry') {
          this.$store.commit('$_industry/updateIndustryDisplayMode', 'single');
        } else if (this.comparisonMode === 'date') {
          if (this.comparisonYears === '1') {
            this.$store.commit('$_industry/updateIndustryDisplayMode', 'double');
          } else if (this.comparisonYears === '3') {
            this.$store.commit('$_industry/updateIndustryDisplayMode', 'table');
          }
        }
        this.$store.commit('updateIndustryLoadingState', 'stopped');
      })
        .catch((error) => { // eslint-disable-next-line
          alert(`Looks like a connection error connecting to our database. Please refresh the page and try again. - ${error}`);
        });
    },
    renderCharts() {
      this.industryOverviewData.base = this.getDataObject(
        {
          comparison: 'base',
          type: 'data',
          dataFormat: this.dataFormat,
          rareMode: this.rareMode,
        },
      );
      this.industryOverviewLabels.base = this.getDataObject(
        {
          comparison: 'base',
          type: 'labels',
          dataFormat: this.dataFormat,
          rareMode: this.rareMode,
        },
      );
      if (this.$store.getters.comparisonMode === 'date'
          && this.comparisonYears === '1') {
        this.industryOverviewData.prevYear1 = this.getDataObject(
          {
            comparison: 'prevYear1',
            type: 'data',
            dataFormat: this.dataFormat,
            rareMode: this.rareMode,
          },
        );
        this.industryOverviewLabels.prevYear1 = this.getDataObject(
          {
            comparison: 'prevYear1',
            type: 'labels',
            dataFormat: this.dataFormat,
            rareMode: this.rareMode,
          },
        );
      } else {
        this.industryOverviewData.prevYear1 = new Array(
          this.industryOverviewData.base.length,
        ).fill(0);
        this.industryOverviewLabels.prevYear1 = new Array(
          this.industryOverviewLabels.base.length,
        ).fill('');
      }

      if (this.$store.getters.comparisonMode === 'date'
          && this.comparisonYears === '3') {
        this.industryOverviewTable = this.getDataTable(
          { dataFormat: this.dataFormat },
        );
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .legend-row {
    margin: 35px 0 0 0;
  }

  .graph-row {
    margin-top: 35px;
  }

  .topSpacer {
    margin-top: 25px;
    margin-bottom: 40px;
    padding-bottom: 25px;
    border-bottom: solid 1px $common-mid-grey;
  }

  .divider {
    border-left: 1px solid $common-mid-grey;
    margin-left: 20px;
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 4px;
    margin: 0;
  }

</style>
